import { injectIntl } from "react-intl";
import './FooterMain.css';
const FooterMainComponent = ({ selectedActiveTab, isPrompt }) => {
  const renderMain = (): JSX.Element => {
    return (
      <footer>
        <div className={`footer-area ${(selectedActiveTab === '1' || selectedActiveTab === '3' || isPrompt) ? 'full-width' : ''}`}>
          <a href="https://go.microsoft.com/fwlink/?LinkId=518021" target="_blank" rel="noopener noreferrer">
            Data Privacy Notice
          </a>
          <p>Microsoft confidential</p>
        </div>
      </footer >
    );
  };

  return renderMain();
};

export const FooterMain = injectIntl(FooterMainComponent);

// Generated by Copilot
// updated on: 2026-07-28 | 1 line updated | [Auto Generated] | Updated the footer Data Privacy Notice URL | Time Taken 1 min